// src/routes/UserRoutes.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import RequireAdmin from "../components/common/RequireAdmin";
import NotFound from "../pages/404";
import Overview from "../pages/dashboard/Overview";
import ContactsPage from "../pages/dashboard/ContactsPage";
import PaymentsPage from "../pages/dashboard/PaymentsPage";
import UsersPage from "../pages/dashboard/UsersPage";
import FollowUpsPage from "../pages/dashboard/FollowUpsPage";

const UserRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Admin-only area */}
      <Route element={<RequireAdmin />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Overview />} />
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="follow-ups" element={<FollowUpsPage />} />
          <Route path="users" element={<UsersPage />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default UserRoutes;
